import React, { Component } from "react";
import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { createMuiTheme, Paper, Popper, TextField } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import Moment from "moment";
import styled, { css } from "styled-components";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import COLORS from "scss/colors.module.scss";
import {
  getFormat,
  formatDate,
} from "../../../list/views/table/helpers/dateFormatter";
import { DIMENSIONS } from "utils/Dimensions";
const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: { 500: COLORS.THEME_COLOR },
  },
});

export default class DateInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      pickerOpen: this.props.isPickerOpenByDefault || false,
      formattedValue: false,
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(this);
    this.pickerInputRef = React.createRef();
    this.dateEditContainer = React.createRef();
    this.escFunction = this.escFunction.bind(this);
  }

  handleChange = (date) => {
    if (this.props.isFormattedDate) {
      let moment = this.props.isDateTime ? Moment(date) : Moment(date).set({ hours: 0, minutes: 0, seconds: 0 })
      if (moment.year() === 2001 && !(date || "").includes("2001")) {
        moment.set("year", Moment().year());
      }
      this.props.onChange( moment.format("YYYY-MM-DDTHH:mm:ss"));
    } else {
      this.props.onChange(new Date(date));
    }
    this.setState({ value: date });
  };

  arrowKeyNavigation = (event) => {
    if ([13].indexOf(event.keyCode) > -1) {
      if (this.props.saveOnEnter) {
        this.handleChange(
          Moment(this.state.value, "YYYY-MM-DD HH:mm:ss").isValid()
            ? this.state.value
            : new Date(),
          true
        );
      } else {
        this.setState({ pickerOpen: false });
      }
    }
  };
  escFunction(event) {
    if (event.keyCode === 27) {
      this.setState({ pickerOpen: false });
    }
  }

  cellFocusFunction() {
    if (
      window.navigator?.vendor.includes("Apple") &&
      window.navigator?.userAgent.includes("Safari") &&
      this.props?.rowHeight
    ) {
      let dateEditContainerClass = document.querySelector(".dateEditContainer");
      if (this.props.rowHeight <= DIMENSIONS.cell_height_compact) {
        dateEditContainerClass
          ? (dateEditContainerClass.style.marginTop = "-6px")
          : null;
      }
    }
  }

  componentDidMount() {
    this.setState({ anchorEl: this.dateEditContainer.current });
    window.addEventListener("keydown", this.arrowKeyNavigation);
    window.addEventListener("keydown", this.escFunction, false);
    this.cellFocusFunction();
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.arrowKeyNavigation);
    window.removeEventListener("keydown", this.escFunction, false);
  }

  getDateObjFromValue(date) {
    let moment = Moment(date);
    if (moment.year() === 2001 && !(date || "").includes("2001")) {
      moment.set("year", Moment().year());
    }
    return moment;
  }

  render() {
    const Renderer = !this.props.isDateTime
      ? KeyboardDatePicker
      : KeyboardDateTimePicker;
    return (
      <ClickAwayListener
        onClickAway={() => {
          if (this.state.pickerOpen === false && this.props.propsApi) {
            this.props.propsApi.stopEditing(false);
          }
          this.setState({ pickerOpen: false });
        }}
      >
        <StyledDiv
          ref={this.dateEditContainer}
          className={this.props.className ? "dateEditContainer" : null}
          isRowView={this?.props?.InputProps ? true : false}
        >
          <TextField
            onClick={(e) => {
              this.setState({ pickerOpen: true });
              this.setState({ anchorEl: this.dateEditContainer.current });
            }}
            inputRef={this.pickerInputRef}
            // InputProps={{ disableUnderline: !this.props.underLine }}
            InputProps={{
              disableUnderline: !this.props.underLine,
              ...(this.props.InputProps || {}) // merge props from parent
            }}
            autoFocus={this.props.autoFocus ? true : false}
            onChange={(e) => {
              this.setState({ formattedValue: true });
              this.handleChange(e.target.value);
            }}
            className={!Moment(this.state.value).isValid() && "invalid_date"}
            value={
              this.state.value === "0000-00-00" ||
              this.state.value === "0000-00-00 00:00:00" ||
              !this.state.value
                ? null
                : this.state.formattedValue
                ? this.state.value
                : Moment(this.state.value).format(
                    getFormat(this.props.format, this.props.isDateTime)
                  )
            }
          />

          <StyledPopper
            className="ag-custom-component-popup"
            open={this.state.pickerOpen}
            anchorEl={this.state.anchorEl}
            styledPopper={this.props.styledPopper}
          >
            <StyledPaper>
              <ThemeProvider theme={defaultMaterialTheme}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <Renderer
                    variant="static"
                    container="inline"
                    onClose={() => {
                      this.setState({ pickerOpen: false });
                      this.props?.rowHeight ? this.pickerInputRef.current?.focus() : null;
                    }}
                    allowKeyboardControl={false}
                    minDate={"01/01/1800"}
                    maxDate={"01/01/2100"}
                    minDateMessage=""
                    maxDateMessage=""
                    invalidDateMessage=""
                    onBlur={() => {
                      this.pickerInputRef.current?.focus();
                    }}
                    autoOk={true}
                    value={
                      this.state.value === "0000-00-00 00:00:00"
                        ? null
                        : this.getDateObjFromValue(this.state.value)
                    }
                    format={getFormat(this.props.format, this.props.isDateTime)}
                    onChange={(date) => {
                      this.setState({ formattedValue: false });
                      this.handleChange(date);
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </StyledPaper>
          </StyledPopper>
        </StyledDiv>
      </ClickAwayListener>
    );
  }
}

const StyledPopper = styled(Popper)`
  z-index: 2222;
  ${(props) =>
    props.styledPopper &&
    css`
      margin-bottom: 100px;
      margin-right: 70px;
    `}
`;

const StyledDiv = styled.div`
  width: ${({ isRowView }) => (isRowView ? "372px" : "188px")};
  height: ${({ isRowView }) => (isRowView ? "40px" : "48px")};
`;

const StyledPaper = styled(Paper)`
  margin-top: 10px;
  margin-bottom: 10px;
`;
